import { generateBooleanSchema, generateRootObjectSchema, generateColorSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseParticleSpec, GetParticlePropsType, GetParticleSchemaType, generateParticleContainerSchema } from "components/cards/particles/BaseParticleSpec";
import { TextParticleSpec } from "../Text/spec";
import { ImageParticleSpec } from "../Image/spec";

export const FormTextInputParticleSpec = new BaseParticleSpec("Form Text Input", generateRootObjectSchema({
    container: generateParticleContainerSchema(),
    backgroundColor: generateColorSchema("Background Color", "The color of the background within the input box.", {
      defaultValue: "white"
    }),
    errorColor: generateColorSchema("Error Color", "The color of the error highlighting.", {
      defaultValue: "#ff4800"
    }),
    inputText: TextParticleSpec.generateSchema("Input Text", "The text for the input box.", {
      defaultValues: { color: "black" }
    }),
    placeholderText: TextParticleSpec.generateSchema("Placeholder Text", "Any specified text becomes the placeholder for the input.", {
      defaultValues: { text: "Placeholder", color: "#949494" }
    }),
    required: generateBooleanSchema("Required Input", "Indicates that this input is required.", {
      defaultValue: false
    }),
    type: generateStringSchema("Input Type", "Type of Text Input", {
      choices: ['', 'phone'],
      choiceTitles: ['', 'Phone Number'],
      defaultValue: '',
    }),
    isAnimated: generateBooleanSchema("Animated Labels", "Animate Label Text.", {
      defaultValue: true
    }),
    showIcon: generateBooleanSchema("Show Icon", "Show icon in input field.", {
      defaultValue: false
    }),
    filledIcon: ImageParticleSpec.generateSchema("Filled Icon", "Icon shown when input field is filled"),
    errorIcon: ImageParticleSpec.generateSchema("Error Icon", "Icon shown when input field has an error"),
}));

export const specification = FormTextInputParticleSpec;

export type FormTextInputParticleSchema = GetParticleSchemaType<typeof FormTextInputParticleSpec>;

export type FormTextInputParticleProps = GetParticlePropsType<typeof FormTextInputParticleSpec>;
